import { CardPrinterPagePrintJobsTab } from "@features/card-printer/components/CardPrinterPagePrintJobsTab";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/assets/card-printer/print-jobs")({
    component: CardPrinterPagePrintJobsTab,
    staticData: {
        crumb: {
            label: "Print jobs"
        }
    }
});
